import { useEffect, useState } from "react";
import { m, AnimatePresence } from "framer-motion";
import { Phone } from "lucide-react";
import { LOCATIONS } from "../data/site";
import { useBookingMode } from "../hooks/useBookingMode";

export const MobileBookBar = () => {
  const [show, setShow] = useState(false);
  const { bookProps } = useBookingMode();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 260);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <m.div
          data-testid="mobile-sticky-booking-bar"
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-[70] border-t border-[#c5a059]/25 bg-[#0a0d12]/96 backdrop-blur-xl lg:hidden"
          style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
        >
          <div className="flex items-stretch gap-2 px-3 pt-3">
            <a
              href={`tel:${LOCATIONS[0].tel}`}
              data-testid="mobile-bar-call"
              aria-label="Call The Vault Barber Co."
              className="flex min-h-[52px] w-[56px] shrink-0 items-center justify-center border border-white/15 text-[#e2cf9e] active:bg-white/10"
            >
              <Phone size={18} />
            </a>
            {LOCATIONS.map((l, i) => (
              <a
                key={l.id}
                {...bookProps(l)}
                data-testid={`mobile-bar-book-${l.id}`}
                className={`flex min-h-[52px] flex-1 items-center justify-center px-2 text-center font-cond text-[13px] font-bold uppercase leading-none tracking-[0.12em] ${
                  i === 0
                    ? "bg-[#c5a059] text-[#0a0d12] active:bg-[#d8b46b]"
                    : "border border-[#c5a059]/45 text-[#e2cf9e] active:bg-[#c5a059]/15"
                }`}
              >
                Book {l.label}
              </a>
            ))}
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
};
